<template>
  <div class="coupon-modal-box" v-if="visible">
   <div class="coupon-modal">
      <div class="coupon-content">
        <div class="coupon-title">恭喜你获得：</div>
        <div class="coupon-info">
          <div class="coupon-type">
            <div class="coupon-type-name">
              {{formData.type =='1'?' 满减券':(formData.type =='2'?'立减券':'折扣券')}}
            </div>
          </div>
          <div class="coupon-detail">
            <div class="coupon-name-box">
              <div class="coupon-name" v-if="formData.type =='1'">
                满{{ formData.orderPrice }}元减{{formData.discount}}元
                <span class="coupon-type-desc">
                  （新人专属）
                </span>
              </div>
              <div class="coupon-name" v-else-if="formData.type =='2'">
                {{formData.discount}}元抵扣券
                <span class="coupon-type-desc">
                  （新人专属）
                </span>
              </div>
              <div class="coupon-name"  v-else-if="formData.type =='3'">
                {{formData.discount/10 }}折券
                <span class="coupon-type-desc">
                  （新人专属）
                </span>
              </div>
            </div>
            <div class="coupon-time">有效期：{{formData.startDate}}—{{formData.endDate}}</div>
          </div>
        </div>
        <div class="coupon-desc">
          优惠券可在“个人中心”-“我的优惠券”中查看
        </div>
        <div class="coupon-btn" @click="clickConfirm">
          立即领取
        </div>
      </div>
      <div class="coupon-cancel" @click="cancel">&nbsp;</div>
   </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { Toast } from "vant"; 
import moment from 'moment'
export default {
  name: "CouponModal",
  computed:{
    ...mapState(['user'])
  },
  mounted() {
    if (this.user.userInfo&&this.user.userInfo.coupons&&this.user.userInfo.coupons.length&&!this.user.izReceive) {
      this.formData = this.user.userInfo.coupons[0]
      this.formData.endDate = moment(this.formData.endDate).format('YYYY-MM-DD')
      this.formData.startDate = moment(this.formData.startDate).format('YYYY-MM-DD')
      this.visible =true
    }
   
  },
  data () {
    return {
      visible: false,
      formData: {
        
      }
    }
  },
  methods: {
    showModal() {
      this.visible=!this.visible
    },
    clickConfirm() {
      Toast('领取成功！');
      this.$store.dispatch('submitIzReceive',true)
      this.visible=false
    },
    cancel() {
      this.visible=false
      this.$emit("cancelEvent");
    }
  }
}
</script>
<style  lang='scss' scoped>
.coupon-modal-box{
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,.5);
  z-index: 99999;
  .coupon-modal{
    height: 700px;
    width:680px;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background: url('~@/assets/images/lihe.png') no-repeat center center;
    background-size:100% 100% ;
    .coupon-title{
      padding-top:210px;
      text-align: center;
      color: #654828;
      font-weight: 500;
      font-size: 30px;
      line-height: 50px;
      padding-bottom: 18px;
    }
    .coupon-info{
      display: flex;
      padding: 0 20%;
      height: 110px;
    }
    .coupon-type{
      display: flex;
      align-items: center;
      padding:0 15px;
      width: 40px; 
      .coupon-type-name{
        color: #654828;
        font-size: 24px;
        writing-mode: vertical-rl;
      }
    }
    .coupon-detail{
      padding: 15px 15px 10px;
      width: 100%;
      box-sizing:border-box;
    }
    .coupon-name-box{
      height: 60px;
      text-align: center;
    }
    .coupon-name{
      color: #e72e2c;
      font-weight: 600;
      font-size: 26px;
    } 
    .coupon-type-desc{
      color: #e72e2c;
      font-size: 20px;
      font-weight: 400;
    } 
    .coupon-time{
      color: #654828;
      font-size: 18px;
      text-align: center;
    }
    .coupon-desc{
      padding: 0 19%;
      color: #654828;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      height: 110px;
    }
    .coupon-btn{
      text-align: center;
      line-height: 68px;
      font-size: 24px;
      color: #f6e8c5;
    }
    .coupon-cancel{
      position: absolute;
      left: calc(50vw - 80px);
      bottom: -50px;
      background: url('~@/assets/images/guanbi.png') no-repeat center center;
      background-size:99% 99%;
      width: 80px;
      height: 80px;
    }
  }
}
</style>